exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?{\"minimize\":true,\"sourceMap\":true}!bootstrap-vue/dist/bootstrap-vue.min.css"), "");

// module
exports.push([module.id, ".actions>[data-v-469aaae3]{font-size:24px;margin-left:20px;cursor:pointer}", "", {"version":3,"sources":["F:/myugfront/src/components/clubs/projects.vue"],"names":[],"mappings":"AAEA,2BACI,eAAgB,AAChB,iBAAkB,AAClB,cAAgB,CACnB","file":"projects.vue","sourcesContent":["\n@import '~bootstrap-vue/dist/bootstrap-vue.min.css';\n.actions > *[data-v-469aaae3] {\n    font-size: 24px;\n    margin-left: 20px;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-469aaae3","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/clubs/projects.vue
// module id = 1172
// module chunks = 34